/**
 * La version affichee, et desormais enregistree avec chaque plantage.
 *
 * Elle vivait dans index.tsx, que trois composants importaient — un point
 * d'entree n'est pas un module de constantes, mais tant qu'ils etaient charges
 * paresseusement le cycle se resolvait tout seul.
 *
 * La remontee d'erreurs, elle, est importee par la frontiere racine que index
 * monte lui-meme : le cycle aurait ete evalue pendant l'initialisation, et la
 * constante lue avant sa declaration. D'ou ce fichier.
 */
/**
 * La version annoncee aux utilisateurs : la date du build, en AA.MM.JJ.
 *
 * Elle etait une constante editee a la main — « 2.4.22.1 », datee du
 * 16/04/2026 alors que les builds tournaient en aout. Une version qu'on doit
 * penser a monter est une version qu'on oublie de monter, et deux bundles
 * differents finissent par porter la meme chaine.
 *
 * La date resout les deux : on ne peut pas oublier de l'incrementer, et elle
 * est ordonnee — entre deux utilisateurs, on sait immediatement lequel est en
 * retard. C'est tout ce qu'on lui demande depuis que `version_build` porte le
 * SHA.
 *
 * `REACT_APP_VERSION` est pose par le script de deploiement, qui derive la
 * date de son horodatage de release. En local il n'y a pas de deploiement,
 * donc pas de date : « dev » est alors la reponse honnete.
 */
export const version_annoncee = process.env.REACT_APP_VERSION || "dev";

/**
 * La version reellement construite.
 *
 * `REACT_APP_BUILD` est pose par le meme script, et vaut exactement le nom du
 * repertoire de release — `HORODATAGE-SHA-SHAENV`. D'un signalement, on va
 * donc au repertoire sans traduire.
 *
 * Voir le ticket 018.
 */
export const version_build = process.env.REACT_APP_BUILD || `${version_annoncee}-local`;

/**
 * Ce qu'on affiche et ce qu'on transmet.
 *
 * L'utilisateur lit un palier, le diagnostic lit un build : les deux tiennent
 * dans la meme chaine sans qu'aucun ne perde.
 */
export const version_timed = process.env.REACT_APP_BUILD
    ? `${version_annoncee} (${process.env.REACT_APP_BUILD})`
    : version_annoncee;
